/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationMessage } from '../../models/notification-message';
import { ProductCategoryDto } from '../../models/product-category-dto';

export interface ApiProductcategoryPut$Params {
  'api-version'?: string;
      body?: ProductCategoryDto
}

export function apiProductcategoryPut(http: HttpClient, rootUrl: string, params?: ApiProductcategoryPut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiProductcategoryPut.PATH, 'put');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiProductcategoryPut.PATH = '/api/productcategory';
